import { getMimeTypeExtensionMap } from '@common/utils/file'

import { UnsubscribedMessage } from './unsubscribed-message'

export const CLASSNAME_PATTERN_COLOR = 'm-editor-fc'

export const COLORS_SCHEME = {
  DEFAULT: `${CLASSNAME_PATTERN_COLOR}__default`,
  GRAY: `${CLASSNAME_PATTERN_COLOR}__gray`,
  BLUE_1: `${CLASSNAME_PATTERN_COLOR}__blue-1`,
  BLUE_2: `${CLASSNAME_PATTERN_COLOR}__blue-2`,
}

export const FONT_COLORS_LIST = [
  {
    order: 1,
    cssValue: '#8a96a3',
    value: COLORS_SCHEME.GRAY,
  },
  {
    order: 2,
    cssValue: '#00aff0',
    value: COLORS_SCHEME.BLUE_1,
  },
  {
    order: 3,
    cssValue: '#1b98e0',
    value: COLORS_SCHEME.BLUE_2,
  },
  {
    order: 4,
    isDivider: true,
  },
  {
    order: 5,
    cssValue: '',
    isDefault: true,
    value: COLORS_SCHEME.DEFAULT,
  },
]

export const CLASSNAME_PATTERN_SIZE = 'm-editor-fs'

export const SIZES_SCHEME = {
  DEFAULT: `${CLASSNAME_PATTERN_SIZE}__default`,
  LG: `${CLASSNAME_PATTERN_SIZE}__lg`,
  L: `${CLASSNAME_PATTERN_SIZE}__l`,
  S: `${CLASSNAME_PATTERN_SIZE}__s`,
  SM: `${CLASSNAME_PATTERN_SIZE}__sm`,
}

export const FONT_SIZES_LIST = [
  {
    order: 1,
    cssValue: '26px',
    textKey: 'Largest',
    value: SIZES_SCHEME.LG,
  },
  {
    order: 2,
    cssValue: '20px',
    textKey: 'Large',
    value: SIZES_SCHEME.L,
  },
  {
    order: 3,
    textKey: 'Default',
    isDefault: true,
    value: SIZES_SCHEME.DEFAULT,
  },
  {
    order: 4,
    cssValue: '14px',
    textKey: 'Small',
    value: SIZES_SCHEME.S,
  },
  {
    order: 5,
    cssValue: '12px',
    textKey: 'Smallest',
    value: SIZES_SCHEME.SM,
  },
]

export const MESSAGE_PRICE_RANGE = {
  MIN: 3,
  MAX: 200,
}

export const ACCEPTABLE_FORMARS = getMimeTypeExtensionMap({
  types: ['video', 'image', 'audio'],
})

export const canNotSendReasonToMessage: Record<string, string | JSX.Element> = {
  unsubscribed: <UnsubscribedMessage />,
  restricted: 'User is restricted',
  muted: 'User is restricted',
  chat_unavailable: 'Chat is unavailable',
}

export const NON_EXISTENT_USER_ID = -1
